import React, { useState } from 'react';

import { Grid, Typography, FormControl, Select, MenuItem } from '@mui/material';
import { BorderBottom } from '@mui/icons-material';
import { greyOutEmptyTextField } from '../../Helpers/helpers';

const InstallReportTraining = (props) => {
  const handleTraining = props.handleTraining;
  const [min_max, set_min_max] = useState(
    props.trainingData === undefined ? '' : props.trainingData.min_max || ''
  );
  const [emegergency_numbers, set_emegergency_numbers] = useState(
    props.trainingData === undefined
      ? ''
      : props.trainingData.emegergency_numbers || ''
  );
  const [auto_defrost, set_auto_defrost] = useState(
    props.trainingData === undefined
      ? ''
      : props.trainingData.auto_defrost || ''
  );
  const [condensor_position, set_condensor_position] = useState(
    props.trainingData === undefined
      ? ''
      : props.trainingData.condensor_position || ''
  );

  const handleChange = (event) => {
    switch (event.target.name) {
      case 'min_max':
        set_min_max(event.target.value);
        break;
      case 'emegergency_numbers':
        set_emegergency_numbers(event.target.value);
        break;
      case 'auto_defrost':
        set_auto_defrost(event.target.value);
        break;
      case 'condensor_position':
        set_condensor_position(event.target.value);
        break;
      default:
        break;
    }
    handleTraining(event.target.name, event.target.value);
  };

  return (
    <>
      <Grid
        item
        //   border={'grey solid 1px'}
        // marginTop={1}
        md={9}
        xs={9}
        borderLeft='solid grey 1px'
        borderRight='solid grey 1px'
        borderBottom='solid grey 1px'
        borderTop='solid grey 1px'
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='center'
        >
          Maximum load line shown and impact of over merchandising explained:
        </Typography>
      </Grid>
      <Grid
        item
        md={3}
        xs={3}
        borderRight='solid grey 1px'
        borderBottom='solid grey 1px'
        borderTop='solid grey 1px'
        sx={{ background: greyOutEmptyTextField(min_max)}}
      >
        <FormControl fullWidth>
          <Select
            className='input-print-style'
            size='small'
            labelId='min_max_label'
            id='min_max'
            name='min_max'
            value={min_max}
            onChange={handleChange}
          >
            <MenuItem value='Yes'>Yes</MenuItem>
            <MenuItem value='No'>No</MenuItem>
            <MenuItem value='N/A'>N/A</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid
        item
        //   border={'grey solid 1px'}
        // marginTop={1}
        md={9}
        xs={9}
        borderLeft='solid grey 1px'
        borderRight='solid grey 1px'
        borderBottom='solid grey 1px'
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='center'
        >
          Contact number provided in case of support:
        </Typography>
      </Grid>
      <Grid
        item
        md={3}
        xs={3}
        borderRight='solid grey 1px'
        borderBottom='solid grey 1px'
        sx={{ background: greyOutEmptyTextField(emegergency_numbers)}}
      >
        <FormControl fullWidth>
          <Select
            className='input-print-style'
            size='small'
            labelId='emegergency_numbers_label'
            id='emegergency_numbers'
            name='emegergency_numbers'
            value={emegergency_numbers}
            onChange={handleChange}
          >
            <MenuItem value='Yes'>Yes</MenuItem>
            <MenuItem value='No'>No</MenuItem>
            <MenuItem value='N/A'>N/A</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid
        item
        md={9}
        xs={9}
        borderLeft='solid grey 1px'
        borderRight='solid grey 1px'
        borderBottom='solid grey 1px'
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='center'
        >
          Auto defrost explained:
        </Typography>
      </Grid>
      <Grid
        item
        md={3}
        xs={3}
        borderRight='solid grey 1px'
        borderBottom='solid grey 1px'
        sx={{ background: greyOutEmptyTextField(auto_defrost)}}
      >
        <FormControl fullWidth>
          <Select
            className='input-print-style'
            size='small'
            labelId='auto_defrost_label'
            id='auto_defrost'
            name='auto_defrost'
            value={auto_defrost}
            onChange={handleChange}
          >
            <MenuItem value='Yes'>Yes</MenuItem>
            <MenuItem value='No'>No</MenuItem>
            <MenuItem value='N/A'>N/A</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid
        item
        //   border={'grey solid 1px'}
        // marginTop={1}
        md={9}
        xs={9}
        borderLeft='solid grey 1px'
        borderRight='solid grey 1px'
        borderBottom='solid grey 1px'
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='center'
        >
          Condenser position shown and maintenance explained:
        </Typography>
      </Grid>
      <Grid
        item
        md={3}
        xs={3}
        borderRight='solid grey 1px'
        borderBottom='solid grey 1px'
        sx={{ background: greyOutEmptyTextField(condensor_position)}}
      >
        <FormControl fullWidth>
          <Select
            className='input-print-style'
            size='small'
            labelId='condensor_position_label'
            id='condensor_position'
            name='condensor_position'
            value={condensor_position}
            onChange={handleChange}
          >
            <MenuItem value='Yes'>Yes</MenuItem>
            <MenuItem value='No'>No</MenuItem>
            <MenuItem value='N/A'>N/A</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
        borderRight='solid grey 1px'
        borderLeft='solid grey 1px'
        borderBottom='solid grey 1px'
        height='40px'
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}
      >
        <Typography fontWeight='700' color='#ff0000' paddingLeft={1} size='small'>
          NB: Cabinet to run 1 ½ - 2 hrs prior to merchandise or temperature at
          -18 or colder!
        </Typography>
      </Grid>
    </>
  );
};

export default InstallReportTraining;
